import React from 'react';
import Typography from '@gogame/ui/Typography';
import captureError from './captureError';

export class FormErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error) {
    captureError(error, { cause: 'Form' });
  }

  render() {
    if (this.state.hasError) {
      return (
          <Typography color={'error'} variant={'subtitle2'}>
            FormErrorBoundary: Form catch{`${this.state.error.name}: ${this.state.error.message}`}
          </Typography>
      );
    }

    return this.props.children;
  }
}
